import styled from '@emotion/styled';

import {mixinSVGIcon} from '@ELib/styles/mixins';

export const ELink = styled.a`
  color: var(--color-core-link);
  font-size: var(--font-size-small);
  width: fit-content;
  cursor: pointer;

  svg {
    ${mixinSVGIcon}
    align-self: center;
  }
`;
